/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactPointTypeModel } from '../../models/contact-point-type-model';

export interface ContactPointTypeIdGet$Params {
  id: string;
}

export function contactPointTypeIdGet(http: HttpClient, rootUrl: string, params: ContactPointTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ContactPointTypeModel>> {
  const rb = new RequestBuilder(rootUrl, contactPointTypeIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ContactPointTypeModel>;
    })
  );
}

contactPointTypeIdGet.PATH = '/ContactPointType/{id}';
